"use client";

import { BraveheartIcon, JokerIcon } from "@/components/ui/CustomIcons";
import { Tournament } from "@/types";
import { useTranslations } from "next-intl";

interface TeamDrawerCardsProps {
  jokerCards: number;
  braveheartCards: number;
  tournament: Tournament;
}

/**
 * TeamDrawerCards - Displays joker and braveheart cards in drawer
 */
export function TeamDrawerCards({
  jokerCards,
  braveheartCards,
  tournament,
}: TeamDrawerCardsProps) {
  const t = useTranslations();

  return (
    <div className="mt-3 pt-3 border-t border-white/5">
      <div className="grid grid-cols-2 gap-2">
        {/* Joker Cards */}

        <div className="flex flex-col items-center gap-1.5 p-2.5 rounded-lg bg-amber-500/5 border border-amber-500/10 cursor-help">
          <div className="flex items-center gap-0.5">
            {Array.from({
              length: tournament?.jokerCards ?? 0,
            }).map((_, i) => (
              <span
                key={i}
                className={`text-lg transition-[opacity,filter] ${
                  i >= jokerCards ? "opacity-20 grayscale" : ""
                }`}
              >
                <JokerIcon />
              </span>
            ))}
          </div>
          <span className="text-xs text-amber-400/80 text-center uppercase tracking-wide">
            {t("teams.jokerCards", {
              count: jokerCards,
              max: tournament?.jokerCards ?? 0,
            })}
          </span>
        </div>

        {/* Braveheart Cards */}

        <div className="flex flex-col items-center gap-1.5 p-2.5 rounded-lg bg-amber-500/5 border border-amber-500/10 cursor-help">
          <div className="flex items-center gap-0.5">
            {Array.from({
              length: tournament?.braveheartCards ?? 0,
            }).map((_, i) => (
              <span
                key={i}
                className={`text-lg transition-[opacity,filter] ${
                  i >= braveheartCards ? "opacity-20 grayscale" : ""
                }`}
              >
                <BraveheartIcon />
              </span>
            ))}
          </div>
          <span className="text-xs text-amber-400/80 text-center uppercase tracking-wide">
            {t("teams.braveheartCards", {
              count: braveheartCards,
              max: tournament?.braveheartCards ?? 0,
            })}
          </span>
        </div>
      </div>
    </div>
  );
}
